import gkButton from './Button.vue'

export default gkButton
export {default as btnCtrl} from './config'
